// @ts-nocheck
import React from "react";
import { Container } from "react-components";

import AnchorLink from "../components/anchorLink";
import Layout from "../components/layout";
import Seo from "../components/seo";

import Illustration from "../components/illustration";

import styles from "./404.css";

const NotFoundPage = () => (
    <Layout>
        <Seo title={"404: Not found"} />

        <div className={styles.notFound}>
            <h1 className={styles.title}>Not found</h1>
            <Illustration variant={"paperPlane"} className={styles.paperPlaneImg} />
            <Container size={"page"}>
                <div className={styles.description}>
                    <p>You just hit a route that doesn’t exist</p>
                    <AnchorLink
                        className={styles.button}
                        modifiers={["button", "button-small", "button-outlined", "button-secondary"]}
                        href={"/"}
                    >
                        Take me home
                    </AnchorLink>
                </div>
            </Container>
        </div>
    </Layout>
);

export default NotFoundPage;
